import html from "html-literal";

export default st => html`
  <header>
    <!-- <h2>${st.header}</h2> -->
  </header>
`;
